import { render, staticRenderFns } from "./DormantNotification.vue?vue&type=template&id=2dd54537&scoped=true&"
import script from "./DormantNotification.vue?vue&type=script&lang=js&"
export * from "./DormantNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dd54537",
  null
  
)

export default component.exports